module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "pz13-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#a2",
      "id": "b2"
    }
  }, [_vm._v("Chapter 1:")])]), _vm._v(" "), _c('p', {
    staticClass: "h1a"
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#a3",
      "id": "b3"
    }
  }, [_vm._v("What Is Communication, and Why Should I Care About Doing It Well? ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-4"
    }
  }, [_vm._v("\n\t\t\t\t\tJust off the tops of our heads, most of us think of communication as simply talking.\n\t\t\t\t\tYes, it is that, but it is also much more than that. Communication involves writing.\n\t\t\t\t\tIt also involves knowing what one wants to say and how to say it before speaking\n\t\t\t\t\tor writing. In other words, it involves planning. Knowing how the communication process\n\t\t\t\t\tworks helps a person understand the importance of thinking and planning, as well\n\t\t\t\t\tas the importance of "), _c('i', [_vm._v("effective")]), _vm._v(" communication. ")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "AEb"
    }
  }, [_c('p', {
    staticClass: "ser",
    attrs: {
      "id": "pASP"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-right": "1.5em"
    },
    attrs: {
      "alt": "images/img-13-1.jpg",
      "id": "ASP",
      "src": "images/img-13-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAc3"
    }
  }, [_c('b', [_c('i', [_vm._v("Rule of Thumb:")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAo6"
    }
  }, [_vm._v("\n\t\t\t\t\t\tRemember that communication is a "), _c('i', [_vm._v("PROCESS")]), _vm._v(", not the end result. Writing is "), _c('i', [_vm._v("NOT")]), _vm._v(" the\n\t\t\t\t\t\tfinished written piece of information. Writing is how you get from the idea to the\n\t\t\t\t\t\tfinished product. ")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz13-6"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "AgC"
    }
  }, [_vm._v("Definition")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-7"
    }
  }, [_vm._v("\n\t\t\t\t\tCommunication is the "), _c('i', [_vm._v("process")]), _vm._v(" by which information, ideas, opinions, etc., are exchanged\n\t\t\t\t\t"), _c('span', {
    attrs: {
      "id": "z14-1"
    }
  }, [_vm._v("between two or more people, with the goal of mutual comprehension. Communication\n\t\t\t\t\tis either written or spoken. (Nonverbal communication, which is an integral component\n\t\t\t\t\tof spoken/verbal communication, is addressed in "), _c('span', {
    attrs: {
      "href": "#/chapter04#pz86-1",
      "id": "A0t",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(".) ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-2"
    }
  }, [_vm._v("\n\t\t\t\t\tCommunication requires someone to give (i.e., “send”) the message and someone to\n\t\t\t\t\treceive "), _c('i', [_vm._v("and understand")]), _vm._v(" the message. The goal is for both the sender and receiver\n\t\t\t\t\tof the message to have the same understanding of the information. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-3"
    }
  }, [_c('i', [_vm._v("Effective")]), _vm._v(" communication is the goal. Ineffective communication wastes everyone’s\n\t\t\t\t\ttime and energy. Effective communication delivers information in a clear and concise\n\t\t\t\t\tmanner (meaning short, simple and to the point) and is clearly understood by the\n\t\t\t\t\tperson(s) receiving the information, whether the person is hearing the message or\n\t\t\t\t\treading it. The person should understand the message "), _c('i', [_vm._v("clearly")]), _vm._v(" the "), _c('i', [_vm._v("first")]), _vm._v(" time he or\n\t\t\t\t\tshe hears it or reads it. ")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "AGn"
    }
  }, [_c('p', {
    staticClass: "ser",
    attrs: {
      "id": "pA-H"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-right": "1.5em"
    },
    attrs: {
      "alt": "images/img-14-1.jpg",
      "id": "A-H",
      "src": "images/img-14-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAqg"
    }
  }, [_c('b', [_c('i', [_vm._v("Rule of Thumb:")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAs9"
    }
  }, [_vm._v("\n\t\t\t\t\t\tYour ability to communicate effectively will build a positive image of you and your\n\t\t\t\t\t\tcompany. ")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz14-5"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "AXV"
    }
  }, [_vm._v("What Are the Benefits of Communicating Well?")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-6"
    }
  }, [_vm._v("\n\t\t\t\t\tThe benefits are many. Grasping the importance of these benefits provides an excellent\n\t\t\t\t\tmotive for paying close attention to how you communicate and for "), _c('span', {
    attrs: {
      "id": "z15-1"
    }
  }, [_vm._v("making the effort\n\t\t\t\t\tto continually work on improving your skills. ")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz15-2"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" Your personal image will be positive. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "AtB"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" Your company image will be positive. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "ADOh"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" Customers will understand clearly what products or services you are providing and\n\t\t\t\t\tfor how much; good communication minimizes confusion and misunderstanding. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz15-3"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" Employees will know exactly what you want, what you need from them, what exactly\n\t\t\t\t\tthey are to do, what you expect, etc. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz15-4"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" If you have a boss (or bosses), he or she will know exactly what you are saying,\n\t\t\t\t\twhat you may need, what you would like him/her to do, etc. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz15-5"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" If your position involves possibility for advancements, your odds for getting those\n\t\t\t\t\tadvancements improve significantly. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz15-6"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" Your values and those of your company will be expressed clearly, adding to the\n\t\t\t\t\tpositive image of your company. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz15-7"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" Negotiations with suppliers, business associates and employees will be clear, thus\n\t\t\t\t\tminimizing misunderstandings, miscommunications, hurt feelings, anger, etc. Each\n\t\t\t\t\tperson will clearly understand the other’s position, what may or may not be possible,\n\t\t\t\t\twhat still needs to be discussed and settled, etc. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz16-1"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" Good communications skills automatically lead people to think you are an expert\n\t\t\t\t\tin your field. The opposite, unfortunately and sadly, is quite often true of poor\n\t\t\t\t\tcommunication skills: "), _c('b', [_c('i', [_vm._v("People will mistake poor communication skills for ignorance.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-2"
    }
  }, [_vm._v("\n\t\t\t\t\tThis last benefit often escapes the attention of many business people, as well as\n\t\t\t\t\tthose in every other profession. Unfortunately, most people will notice poor communication\n\t\t\t\t\tskills in others but forget to take note of their own. Make sure you are one of those\n\t\t\t\t\twho "), _c('i', [_vm._v("does")]), _vm._v(" pay attention to any need you may have for improvement in communicating\n\t\t\t\t\t– and then be sure to do something about it. ")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "AdS"
    }
  }, [_c('p', {
    staticClass: "ser",
    attrs: {
      "id": "pAAg"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-right": "1.5em"
    },
    attrs: {
      "alt": "images/img-16-1.jpg",
      "id": "AAg",
      "src": "images/img-16-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAtD"
    }
  }, [_c('b', [_c('i', [_vm._v("Rule of Thumb:")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAWH"
    }
  }, [_vm._v("\n\t\t\t\t\t\tPoor communication skills "), _c('i', [_vm._v("will")]), _vm._v(", unfortunately and unfairly, be mistaken for ignorance.\n\t\t\t\t\t\tNo one ever said that life is fair. ")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz16-4"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "Ai2"
    }
  }, [_vm._v("Written vs. Verbal Communication")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-5"
    }
  }, [_vm._v("\n\t\t\t\t\tYour business activities will continually involve both written and verbal (spoken)\n\t\t\t\t\tcommunication. Both are important. Both are reflections of you and your business.\n\t\t\t\t\tLearning to do both effectively will provide you a clear advantage over those people\n\t\t\t\t\twho do not. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-6"
    }
  }, [_c('i', [_vm._v("Written communication")]), _vm._v(" is information that is written in a letter, in a memo, on the\n\t\t\t\t\tInternet, in e-mails, in "), _c('span', {
    attrs: {
      "id": "z17-1"
    }
  }, [_vm._v("marketing/advertising materials, etc. In other words, something\n\t\t\t\t\tthat the person getting the message (the “receiver”) must read. ")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz17-2"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" Advantages ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz17-3"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Written communication provides a permanent record. Having a paper trail is always\n\t\t\t\t\twise for important information that must be remembered or is needed for your records\n\t\t\t\t\tor for legal reasons. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz17-4"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Written information provides the receiver the ability to read the message at his/her\n\t\t\t\t\tconvenience. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz17-5"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Written information can be read as quickly or as slowly as needed for the reader\n\t\t\t\t\tto absorb the information. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz17-6"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Written information can be reread as often as needed or desired to aid or to refresh\n\t\t\t\t\tone’s memory. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz17-7"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" Disadvantages ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz17-8"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Written communication lacks those all-important nonverbal signals (eye contact,\n\t\t\t\t\tfacial expression, tone of voice, etc.) that enhance or create meaning. (Nonverbal\n\t\t\t\t\tcommunication is discussed further in "), _c('span', {
    attrs: {
      "href": "#/chapter04#pz86-1",
      "id": "AF1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(".) ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz17-9"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" The gap in time from when the message is written to when the message is read can\n\t\t\t\t\tbe significant. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz17-10"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Sending a written message provides no "), _c('span', {
    attrs: {
      "id": "z18-1"
    }
  }, [_vm._v("guarantee as to whether the intended person\n\t\t\t\t\treceived the message or when he/ she might read it. ")])]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz18-2"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" A written message lacks the opportunity for the person receiving it to provide\n\t\t\t\t\timmediate feedback. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz18-3"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" The writer of the message is usually unavailable to answer questions or to clarify\n\t\t\t\t\tany of the information. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz18-4"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Written communications may need storage space if they are in hard copy. Even e-mails\n\t\t\t\t\tmay need to be printed out and filed for the company’s records. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-5"
    }
  }, [_c('i', [_vm._v("Verbal communication")]), _vm._v(" (also commonly referred to as “oral” communication) is an exchange\n\t\t\t\t\tof information done through speaking. It can be a casual conversation with family\n\t\t\t\t\tor friends or an exchange of work-related information on the job or at a meeting\n\t\t\t\t\t– i.e., any verbal exchange no matter with whom or in what circumstances. Spoken\n\t\t\t\t\tcommunication is usually less formal than is written communication – unless, of course,\n\t\t\t\t\tyou are giving a formal presentation to a group at a conference, meeting, etc. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz18-6"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" Advantages ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz18-7"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Verbal communication is immediate. The listener receives the message in the same\n\t\t\t\t\ttime stream in which it is sent. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz18-8"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Verbal messages provide the opportunity for instant feedback from the listener.\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz19-1"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Nonverbal cues are present to enhance and clarify meaning. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz19-2"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" The listener has the ability to ask questions to clarify the message or request\n\t\t\t\t\tadditional information. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz19-3"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Because of the personal contact, verbal communication is far more conducive to\n\t\t\t\t\tbuilding relationships than is written communication. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz19-4"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" Disadvantages ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz19-5"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Verbal messages leave no permanent record or paper trail. If a record is needed,\n\t\t\t\t\tthe parties involved in the conversation must make a written note of the details\n\t\t\t\t\t(topic, place, time, those involved, result, etc.). ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz19-6"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" The listener loses the ability to absorb the message at his/her own pace. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz19-7"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" A verbal message cannot be reviewed or reread to refresh one’s memory. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz19-8"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" The memory of a verbal conversation may be recalled differently by the people involved,\n\t\t\t\t\tsometimes creating confusion, misunderstanding, and even frustration or anger. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-9"
    }
  }, [_vm._v("\n\t\t\t\t\tEach situation must be evaluated for the best way to deliver a message. Judgment\n\t\t\t\t\tcalls such as this will always be part of your daily experience as a manager or business\n\t\t\t\t\towner. While a great deal of everyday "), _c('span', {
    attrs: {
      "id": "z20-1"
    }
  }, [_vm._v("communication in the workplace will be spoken,\n\t\t\t\t\tyou will be faced with those situations in which you must decide if the information\n\t\t\t\t\tmust be delivered in writing, and if so, what form that writing should take (letter,\n\t\t\t\t\te-mail, memo, etc.) ")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz20-2"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "AgCl"
    }
  }, [_vm._v("The Communication Process")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-3"
    }
  }, [_vm._v("\n\t\t\t\t\tCommunication is a two-way process requiring both a sender (i.e., the person giving\n\t\t\t\t\tthe information) and a receiver (i.e., the reader or the listener). Without a listener,\n\t\t\t\t\tyou might as well talk to a post. Without a reader, you might as well send the written\n\t\t\t\t\tinformation to that same inanimate post. The process becomes a circular, back-and-forth\n\t\t\t\t\tprocess as soon as the listener (or reader) responds with any information back to\n\t\t\t\t\tthe person who first sent the message. Even a nod of the head sends a message. ")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "AHS"
    }
  }, [_c('p', {
    staticClass: "ser",
    attrs: {
      "id": "pA_-"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-right": "1.5em"
    },
    attrs: {
      "alt": "images/img-20-1.jpg",
      "id": "A_-",
      "src": "images/img-20-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAhx"
    }
  }, [_c('b', [_c('i', [_vm._v("Rule of Thumb:")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAdJ"
    }
  }, [_vm._v("\n\t\t\t\t\t\tRemember that communication is a two-way (or circular, back-and-forth) process. Effective\n\t\t\t\t\t\tcommunication does not take place without the person on the receiving end clearly\n\t\t\t\t\t\tunderstanding the information. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-5"
    }
  }, [_vm._v("\n\t\t\t\t\tCommunication, especially verbal face-to-face communication, often requires feedback\n\t\t\t\t\t(a response) from the receiver. When feedback occurs, the receiver becomes the sender\n\t\t\t\t\tof new information, and the "), _c('span', {
    attrs: {
      "id": "z21-1"
    }
  }, [_vm._v("original sender becomes the receiver. Sometimes the feedback\n\t\t\t\t\tis short, such as a nod of the head in agreement or acknowledgment, a quick reply\n\t\t\t\t\tlike “Sure thing,” or a shrug of the shoulders. At other times, the conversation\n\t\t\t\t\tgoes back and forth many times with the people involved taking turns being the sender\n\t\t\t\t\tor receiver. For instance, a discussion about the benefits or drawbacks of creating\n\t\t\t\t\ta new logo for the business might involve several people in prolonged back-and-forth\n\t\t\t\t\tdiscussion (i.e., a circular communication process). ")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz21-2"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" Sending messages: ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz21-3"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Know what information needs to be conveyed. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz21-4"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Determine who will receive the message. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz21-5"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Include all necessary information. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz21-6"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Eliminate unnecessary or irrelevant information. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz21-7"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Determine the best way to send the message (letter, memo, e-mail, phone call, in\n\t\t\t\t\tperson, etc.). ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz21-8"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Be sure the message is clear and easy to understand. ")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "Aud"
    }
  }, [_c('p', {
    staticClass: "ser",
    attrs: {
      "id": "pA8m"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-right": "1.5em"
    },
    attrs: {
      "alt": "images/img-22-1.jpg",
      "id": "A8m",
      "src": "images/img-22-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAcG"
    }
  }, [_c('b', [_c('i', [_vm._v("Rule of Thumb:")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAMD"
    }
  }, [_vm._v("\n\t\t\t\t\t\tAlways consider the best way to deliver a message "), _c('i', [_vm._v("before")]), _vm._v(" you send it. Verbal or written?\n\t\t\t\t\t\tPhone call or face-to-face? Letter, memo, e-mail, report, etc? ")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz22-2"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" Receiving messages: ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz22-3"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Written messages: Most readers take the time to make sure they understand a written\n\t\t\t\t\tmessage – especially on the job. With a written message, the reader can absorb the\n\t\t\t\t\tinformation as quickly or slowly as he or she needs or wishes. The message may also\n\t\t\t\t\tbe read at the receiver’s convenience. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz22-4"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Verbal messages: Listening "), _c('i', [_vm._v("effectively")]), _vm._v(" (i.e., making sure the meaning is clearly\n\t\t\t\t\tunderstood) goes far beyond simple hearing. Effective listening is an active, purposeful\n\t\t\t\t\tmental process that rarely comes naturally. Listening for meaning is a "), _c('i', [_vm._v("learned")]), _vm._v(" process\n\t\t\t\t\tthat anyone can learn. ")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "AgP"
    }
  }, [_c('div', {
    staticClass: "ser",
    attrs: {
      "id": "pAag"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-right": "1.5em"
    },
    attrs: {
      "alt": "images/img-22-2.jpg",
      "id": "Aag",
      "src": "images/img-22-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAzX"
    }
  }, [_c('b', [_c('i', [_vm._v("Rule of Thumb:")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAdp"
    }
  }, [_vm._v("\n\t\t\t\t\t\tListening "), _c('i', [_vm._v("effectively")]), _vm._v(" is a learned skill. Anyone can learn it, just as one learns\n\t\t\t\t\t\tto add and subtract or to drive a car. ")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz23-1"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "AJv"
    }
  }, [_vm._v("Some Truths About Listening")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz23-2"
    }
  }, [_vm._v("\n\t\t\t\t\tMost people give little thought to the listening process beyond their natural ability\n\t\t\t\t\tto hear. Contrary to what many people believe, listening is an activity that takes\n\t\t\t\t\tconscious effort, skill and practice to accomplish effectively. Keep in mind that\n\t\t\t\t\tit is a "), _c('i', [_vm._v("learned")]), _vm._v(" skill, and anyone can learn it. The following items provide some\n\t\t\t\t\tclarification about what listening is and is not, as well as what role listening\n\t\t\t\t\tplays in effective communication. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz23-3"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _c('i', [_vm._v("Hearing and listening are completely different processes.")]), _vm._v(" Hearing is an automatic\n\t\t\t\t\tphysiological process, allowing people to hear sounds whether or not they plan to\n\t\t\t\t\tdo so. Short of having a severe hearing impairment, people "), _c('i', [_vm._v("will")]), _vm._v(" hear a sonic boom\n\t\t\t\t\teven if they do not intend to hear it. Listening, on the other hand, is an intentionally\n\t\t\t\t\tactive mental process in which the listener makes a conscious effort to understand\n\t\t\t\t\tinformation being conveyed. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "At9"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Listening does take conscious effort")]), _vm._v(". Listening is an active mental process, not\n\t\t\t\t\ta passive activity. Active listening results in some physiological changes similar\n\t\t\t\t\tto those that occur when a person is exercising. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz23-4"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Both the speaker and the listener are necessary for effective communication to\n\t\t\t\t\ttake place")]), _vm._v(". Speaking is of no use if no one listens to make sure the information\n\t\t\t\t\tis understood. Effective verbal "), _c('span', {
    attrs: {
      "id": "z24-1"
    }
  }, [_vm._v("communication requires both speaking and listening.\n\t\t\t\t\t")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz24-2"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Intelligence has little to do with listening skill")]), _vm._v(". A genius can be a poor listener.\n\t\t\t\t\tIn fact, some geniuses may be poor listeners because they are so busy talking about\n\t\t\t\t\ttheir own ideas and theories that they forget to listen to others. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz24-3"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Good hearing ability has little to do with listening ability")]), _vm._v(". A person with excellent\n\t\t\t\t\thearing may be a poor listener, absorbing little or no information. A deaf person\n\t\t\t\t\tmay be an excellent listener, even though the “listening” takes the form of watching\n\t\t\t\t\tsign language. “Listening” occurs through an active mental process. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz24-4"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Speakers cannot force listeners to pay attention")]), _vm._v(". Through good speaking skills,\n\t\t\t\t\ta person will draw and hold the attention of – and may even captivate – the listeners.\n\t\t\t\t\tEven so, the level of actual “listening” is up to the listener. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz24-5"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Listening skills are gained through learning and practicing effective listening\n\t\t\t\t\ttechniques")]), _vm._v(". No one is born a good listener. The right skills must be learned and\n\t\t\t\t\tpracticed. Practicing poor listening skills only results in strengthening poor listening\n\t\t\t\t\tbehavior. A pitcher who continually practices a lousy curve ball will only get better\n\t\t\t\t\tand better at throwing that lousy curve ball. The same problem occurs if a person\n\t\t\t\t\tkeeps practicing poor listening habits – the poor "), _c('span', {
    attrs: {
      "id": "z25-1"
    }
  }, [_vm._v("habits just get more and more ingrained\n\t\t\t\t\tin the person’s behavior. ")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-left": "2.5em",
      "text-indent": "1.5em"
    },
    attrs: {
      "id": "pz25-3"
    }
  }, [_vm._v("\n\t\t\t\t\tFind a teacher or a good manual on listening skills to learn effective techniques\n\t\t\t\t\tfor listening. (A few basic tips: Make mental notes, take written notes, eliminate\n\t\t\t\t\tor ignore distractions, focus attention on the speaker, concentrate on what the speaker\n\t\t\t\t\tis saying, summarize the information in your head, repeat back to the speaker what\n\t\t\t\t\tyou believe you heard to confirm the information.) People with no training in listening\n\t\t\t\t\tskills tend to understand only about one-fourth of a message. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz25-4"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _c('i', [_vm._v("Good writers or speakers are not necessarily good listeners.")]), _vm._v(" Writing and speaking\n\t\t\t\t\tskills are different from listening skills. Make the effort to learn all three. ")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "AKU"
    }
  }, [_c('p', {
    staticClass: "ser",
    attrs: {
      "id": "pAQF3"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-right": "1.5em"
    },
    attrs: {
      "alt": "images/img-25-1.jpg",
      "id": "AQF3",
      "src": "images/img-25-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pA8g"
    }
  }, [_c('b', [_c('i', [_vm._v("Rule of Thumb:")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAc7"
    }
  }, [_vm._v("\n\t\t\t\t\t\tAlways remember the old saying: “God gave us one mouth and two ears. Use them proportionally.”\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz25-9"
    }
  }, [_vm._v("\n\t\t\t\t\tMost people (including me – I’m no different from anyone else) tend to want to talk\n\t\t\t\t\tmore than they listen. We all need to pay attention to how much time we spend talking\n\t\t\t\t\tand how much time we spend listening. You might be amazed at how much you can learn\n\t\t\t\t\tif "), _c('span', {
    attrs: {
      "id": "z26-1"
    }
  }, [_vm._v("you listen more and talk less. My personal experience has taught me that others\n\t\t\t\t\twill have knowledge or information that I don’t, or they will come up with wonderful\n\t\t\t\t\tideas that just never occurred to me. This same personal experience has also taught\n\t\t\t\t\tme that education level, position in the company and job title have little to do\n\t\t\t\t\twith a person’s intelligence, knowledge or quality of ideas. Everyone has something\n\t\t\t\t\tto teach or offer. ")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "ADP"
    }
  }, [_c('p', {
    staticClass: "ser",
    attrs: {
      "id": "pAsm"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-right": "1.5em"
    },
    attrs: {
      "alt": "images/img-26-1.jpg",
      "id": "Asm",
      "src": "images/img-26-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAvm"
    }
  }, [_c('b', [_c('i', [_vm._v("Rule of Thumb:")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "AI0r"
    }
  }, [_vm._v("\n\t\t\t\t\t\tAlways be prepared to learn something from others, no matter their position or education\n\t\t\t\t\t\tlevel. Neither position nor education can be equated with wisdom or knowledge. Listening\n\t\t\t\t\t\tto others’ ideas can, and often does, reap wonderful results. ")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz26-3"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "AU3"
    }
  }, [_vm._v("Nonverbal Communication:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "Aa2"
    }
  }, [_vm._v("Communicating Without Words")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz26-4"
    }
  }, [_vm._v("\n\t\t\t\t\tNonverbal (i.e., non-word) cues carry "), _c('b', [_c('i', [_vm._v("93%")])]), _vm._v(" of the message in a face-to-face exchange.\n\t\t\t\t\tThis percentage holds true for both formal and informal verbal exchanges. Nonverbal\n\t\t\t\t\tcues such as body language and tone of voice are critical to the meaning of a message.\n\t\t\t\t\tMore details on this topic are found in "), _c('span', {
    attrs: {
      "href": "#/chapter04#pz86-1",
      "id": "AR5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz27-1"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "AL6"
    }
  }, [_vm._v("Barriers to Effective Communication")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz27-2"
    }
  }, [_vm._v("\n\t\t\t\t\tCommunication is affected by internal and external distractions, as well as opinions,\n\t\t\t\t\tattitude, knowledge, skills, etc. Effective communicators minimize or eliminate all\n\t\t\t\t\tdistractions as much as possible. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz27-3"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("External distractions")]), _vm._v(" (people talking, construction outside the building, dogs\n\t\t\t\t\tbarking, heavy traffic, etc.) can make listening difficult because they interfere\n\t\t\t\t\twith hearing, as well as draw attention away from the speaker. When the listener’s\n\t\t\t\t\tattention is not fully on the speaker, clear understanding suffers. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz27-4"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Internal distractions")]), _vm._v(" are those that pop up inside our heads and keep us from focusing\n\t\t\t\t\ton the speaker or on what we are reading. These distractions can be either negative\n\t\t\t\t\tor positive. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "AZi"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Negative internal distractions are those that cause worry, concern, fear, etc.\n\t\t\t\t\tIf a family member, for instance, has a serious illness, concentrating on and clearly\n\t\t\t\t\tunderstanding a spoken or written piece of information may be difficult. The mind\n\t\t\t\t\ttends to wander back to the worry. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    attrs: {
      "id": "pz27-5"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.5em"
    }
  }, [_vm._v("□")]), _vm._v(" Positive internal distractions are those such as excitement about an upcoming trip,\n\t\t\t\t\ta long-time friend coming to town for a much-anticipated visit, an upcoming social\n\t\t\t\t\tevent, etc. Say, for instance, you just checked on the lottery ticket you purchased\n\t\t\t\t\t \n\t\t\t\t\tyesterday and discovered that you won $200,000. Because that amount is not enough\n\t\t\t\t\tto live on for the rest of your life, you can’t quit your job or close up shop and\n\t\t\t\t\tretire, but you certainly find listening to the employee’s problem with a customer\n\t\t\t\t\tto be a difficult task. Yes, we all know where your mind is. ")]), _vm._v(" "), _c('p', {
    staticClass: "pubo",
    staticStyle: {
      "margin-left": "4em",
      "text-indent": "1.4em"
    },
    attrs: {
      "id": "pz28-9"
    }
  }, [_vm._v("\n\t\t\t\t\tInternal distractions can be difficult to ignore or, more accurately, to set aside\n\t\t\t\t\tfor the time being. Remind yourself that as long as you are in a situation in which\n\t\t\t\t\tyou can do nothing about those internal distractions, you might as well concentrate\n\t\t\t\t\ton the speaker or written material requiring your attention. You will take care of\n\t\t\t\t\tthe distractions when the time and situation allow you to do that. Concentrate on\n\t\t\t\t\tthe task at hand: paying attention. Your business may depend on it. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz28-10"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Bypassing")]), _vm._v(" is a situation in which two people have different definitions for the\n\t\t\t\t\tsame word, creating a misunderstanding. Say that a person runs a business in a small\n\t\t\t\t\tMidwest town, and she has a new employee who just moved there from having lived on\n\t\t\t\t\tthe east coast his entire life. She wants to take him to dinner to discuss the report\n\t\t\t\t\ton the Jones-Smith project she wants him to prepare. She designates the restaurant\n\t\t\t\t\t \n\t\t\t\t\tand says she will meet him for dinner. The boss arrives at the restaurant at noon\n\t\t\t\t\tand waits and waits and waits until well after 1:00 p.m. Furious, she returns to\n\t\t\t\t\tthe office to confront the new employee about his missing the meeting. The employee\n\t\t\t\t\tresponds that she specified dinner, and that’s not until 6:00 p.m. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-left": "2.5em",
      "text-indent": "1em"
    },
    attrs: {
      "id": "pz29-8"
    }
  }, [_vm._v("\n\t\t\t\t\tEach person obviously has a different definition for “dinner.” For many Midwesterners,\n\t\t\t\t\tthe three daily meals are breakfast, dinner and supper. For many people living on\n\t\t\t\t\tthe east or west coast, the three meals are breakfast, lunch and dinner. In this\n\t\t\t\t\tinstance, naming the time would have solved the problem. Take time to make sure everyone\n\t\t\t\t\thas the same definition for all the words in the conversation. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz29-9"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Prejudgment")]), _vm._v(" or "), _c('i', [_vm._v("biases")]), _vm._v(" can create a positive or negative impression of a person\n\t\t\t\t\tbefore he or she even says one word. Let’s say a man living and working in Wyoming\n\t\t\t\t\twill attend a business talk presented by a person from New York City. His impression\n\t\t\t\t\tof New Yorkers is that they are rude and arrogant – or as he might say, “uppity.”\n\t\t\t\t\tEven before he hears one word from the speaker, he has formed a negative impression\n\t\t\t\t\tof that person and is less likely to listen carefully or take seriously what the\n\t\t\t\t\tspeaker has to say. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-left": "2.5em",
      "text-indent": "1em"
    },
    attrs: {
      "id": "pz30-1"
    }
  }, [_vm._v("\n\t\t\t\t\tThis same person from Wyoming may have a positive feeling about a speaker from his\n\t\t\t\t\thometown or any town/city in Wyoming and will pay close attention to everything that\n\t\t\t\t\tperson says. These reactions are unintentional – they are just human nature. But\n\t\t\t\t\tbeing aware of possible biases and prejudgments will help us put them aside so that\n\t\t\t\t\twe will listen more "), _c('i', [_vm._v("effectively")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz30-2"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Visual distractions")]), _vm._v(" (e.g., speaker’s appearance) draw the listener’s attention\n\t\t\t\t\taway from the speaker’s words and onto whatever is drawing the listener’s gaze. Professional\n\t\t\t\t\tbusiness people who speak frequently at business meetings, conferences, conventions,\n\t\t\t\t\tetc., make a habit of dressing professionally, i.e., in a business suit. This manner\n\t\t\t\t\tof dress applies to both men and women. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-left": "2.5em",
      "text-indent": "1em"
    },
    attrs: {
      "id": "pz30-3"
    }
  }, [_vm._v("\n\t\t\t\t\tSay, for instance, you attend a day-long business conference and eagerly await the\n\t\t\t\t\tkeynote speaker at the luncheon. The speaker comes out wearing flip-flops, shorts\n\t\t\t\t\t(as in “short-shorts”) and a tank top. He sports tattoos up and down each arm and\n\t\t\t\t\tdisplays a two-day beard growth. He also blows bubbles with the bubble gum in his\n\t\t\t\t\tmouth. Where is your attention? The likelihood of your attention being on what he\n\t\t\t\t\thas to say drops pretty much to zero. Additionally, what happens to the "), _c('span', {
    attrs: {
      "id": "z31-1"
    }
  }, [_vm._v("speaker’s\n\t\t\t\t\tcredibility? That’s absolutely correct: It goes right out the window. ")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-left": "2.5em",
      "text-indent": "1em"
    },
    attrs: {
      "id": "pz31-2"
    }
  }, [_vm._v("\n\t\t\t\t\tGranted, not every situation requires you to wear a business suit, but be sure to\n\t\t\t\t\tdress appropriately for each situation. The owner of a small plumbing business, for\n\t\t\t\t\tinstance, will not likely wear a suit to work, but he may occasionally encounter\n\t\t\t\t\tsituations in which wearing a suit would be appropriate – perhaps meeting with representatives\n\t\t\t\t\tof a major corporation to discuss his/her bid for a project. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz31-3"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Inadequate vocabulary")]), _vm._v(" does "), _c('i', [_vm._v("not")]), _vm._v(" mean a lack of knowing big words that most people\n\t\t\t\t\tdon’t know anyway. It "), _c('i', [_vm._v("does")]), _vm._v(" mean that you need to know the words you need to know.\n\t\t\t\t\tBusiness owners and managers need a basic vocabulary that includes terms like accounts\n\t\t\t\t\tpayable, accounts receivable, tax credit, tax deduction, etc. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-left": "2.5em",
      "text-indent": "1em"
    },
    attrs: {
      "id": "pz31-4"
    }
  }, [_vm._v("\n\t\t\t\t\tEveryone working in a business also needs to possess the necessary vocabulary related\n\t\t\t\t\tto that particular business. People in the lawn and landscaping business must know\n\t\t\t\t\tterms like power raking, aeration, pre-emergent, pavers, flagstone, etc. My background\n\t\t\t\t\tand career involve both business and communication. Consequently, my vocabulary is\n\t\t\t\t\tfilled with words related to business, as well as to communication skills and grammar.\n\t\t\t\t\tBe "), _c('span', {
    attrs: {
      "id": "z32-1"
    }
  }, [_vm._v("sure that your vocabulary has whatever words are needed to talk about and run\n\t\t\t\t\tyour business effectively. ")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz32-2"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Poor listening skills")]), _vm._v(" should by now need little further comment. Concentrate on\n\t\t\t\t\tpaying attention to the information a speaker is conveying. If you haven’t understood\n\t\t\t\t\tclearly, ask questions to clarify the information. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz32-3"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" The role of "), _c('i', [_vm._v("poor writing or speaking skills")]), _vm._v(" in communication should also need little\n\t\t\t\t\tcomment. Tips for improving these skills are found in "), _c('span', {
    attrs: {
      "href": "#/chapter05#pz92-1",
      "id": "AvP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 5")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/chapter08#pz140-1",
      "id": "AOt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/chapter09#pz148-1",
      "id": "AZN",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(". ")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "AyP"
    }
  }, [_c('div', {
    staticClass: "ser",
    attrs: {
      "id": "pAPV"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-right": "1.5em"
    },
    attrs: {
      "alt": "images/img-32-1.jpg",
      "id": "APV",
      "src": "images/img-32-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAB_"
    }
  }, [_c('b', [_c('i', [_vm._v("Rule of Thumb:")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "AJ1"
    }
  }, [_vm._v("\n\t\t\t\t\t\tBe aware of possible barriers to effective communication. Make a list of them to\n\t\t\t\t\t\treview periodically so that you make a habit of eliminating as many of those barriers\n\t\t\t\t\t\tas possible. ")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz32-8"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "AX-"
    }
  }, [_vm._v("Levels of Communication")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz32-9"
    }
  }, [_vm._v("\n\t\t\t\t\tDifferent levels of formality in communication are regularly used by almost everyone.\n\t\t\t\t\tEach specific situation and the people involved determine the level of formality.\n\t\t\t\t\tAt an early age, we all managed to learn by observation and experience when to use\n\t\t\t\t\teach of these varying levels. At age six or seven, we most likely were well aware\n\t\t\t\t\tthat the manner in which we spoke to a teacher, a school principal or a faith leader\n\t\t\t\t\t"), _c('span', {
    attrs: {
      "id": "z33-1"
    }
  }, [_vm._v("(minister, priest, rabbi, imam, etc.) was far different from the manner in which\n\t\t\t\t\twe communicated with our playmates during a neighborhood baseball game or snowball\n\t\t\t\t\tfight. (Yes, chuckling at the memory is the right response.) The following items\n\t\t\t\t\tprovide general descriptions of major categories for levels of formality. ")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz33-2"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Colloquial speech")]), _vm._v(" is that everyday language that usually includes a good deal of\n\t\t\t\t\tslang words and expressions, as well as non-standard “grammar.” This style of speaking\n\t\t\t\t\tis typically used in situations where slang and the local lingo are acceptable to\n\t\t\t\t\teveryone taking part in the conversation. Terminology, slang and colloquial phrases\n\t\t\t\t\twill vary from one part of the country to another. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-left": "2.5em",
      "text-indent": "1em"
    },
    attrs: {
      "id": "pz33-3"
    }
  }, [_vm._v("\n\t\t\t\t\tFor instance, in some areas of the country, a colloquial usage may be, “Beings you’re\n\t\t\t\t\tpicking up supplies anyway, could you also get some …” In other areas the phrasing\n\t\t\t\t\tis the more grammatically correct “As long as you’re going to …” or “Because you’re\n\t\t\t\t\tgoing to …” ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-left": "2.5em",
      "text-indent": "1em"
    },
    attrs: {
      "id": "pz33-4"
    }
  }, [_vm._v(" \n\t\t\t\t\tAnother example is the different terms used for carbonated soft drinks from region\n\t\t\t\t\tto region. I grew up with “pop.” On most of the east coast the term is “soda.” Personally,\n\t\t\t\t\tI like “soda pop” because it becomes understandable to most people across the country.\n\t\t\t\t\tWhen my daughter moved to Atlanta, Georgia, for graduate school, she received a clear\n\t\t\t\t\tlesson in "), _c('span', {
    attrs: {
      "id": "z34-1"
    }
  }, [_vm._v("“regionalisms” when trying to order a “Coke.” The server repeatedly asked\n\t\t\t\t\ther, “What kind?” “Diet Coke,” came her answer. “But what "), _c('i', [_vm._v("kind")]), _vm._v(",” came the question\n\t\t\t\t\tfrom the server again. In that area of the country, “Coke” is frequently used as\n\t\t\t\t\tthe generic term for all soda pop. Apparently one needs to specify Classic Coca-Cola,\n\t\t\t\t\tDiet 7-Up, root beer, and so on. So much for everyone in America speaking the same\n\t\t\t\t\tlanguage. ")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz34-2"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Informal language")]), _vm._v(" is what most people use on a day-to-day basis in most situations.\n\t\t\t\t\tThis informal level is often used in conversations with friends and family or in\n\t\t\t\t\teveryday casual verbal exchanges of information among coworkers. The conversation\n\t\t\t\t\tmay contain some slang, but usually much less than what is found in speech labeled\n\t\t\t\t\t“colloquial.” The grammar is, for the "), _c('i', [_vm._v("most")]), _vm._v(" part, correct but may have some that is\n\t\t\t\t\tnot “strictly” grammatical. A common example is saying, “It was them,” when it technically\n\t\t\t\t\tshould be “It was they.” Sentence fragments are also used frequently in this type\n\t\t\t\t\tof conversation: “Hey, Fred. That order filled yet?” In these informal situations,\n\t\t\t\t\tmost people won’t care and probably won’t even notice. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz34-3"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Business language")]), _vm._v(", especially written communication, needs to be clear, concise,\n\t\t\t\t\t"), _c('span', {
    attrs: {
      "id": "z35-1"
    }
  }, [_vm._v("grammatically correct and free of slang. Grammatical correctness in conversations\n\t\t\t\t\tor brief exchanges with those you work with on a daily basis is often less critical\n\t\t\t\t\tthan it is in conversations with customers or clients. ")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-left": "2.5em",
      "text-indent": "1em"
    },
    attrs: {
      "id": "pz35-6"
    }
  }, [_vm._v("\n\t\t\t\t\tLetters to customers or clients, reports, memos, etc., should use acceptable business\n\t\t\t\t\tlanguage, meaning that complete sentences are used, the grammar is correct, spelling\n\t\t\t\t\tand punctuation are correct and slang is absent. Again, this usage does not mean\n\t\t\t\t\tthat you should sound like a stuffy snob who wants to show off his/her knowledge\n\t\t\t\t\tof big words. Use simple words, but what you do use should be used correctly. It’s\n\t\t\t\t\tas simple as saying “He had gone” instead of “He had went.” ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz35-7"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Formal language")]), _vm._v(" is used for formal speeches or presentations to groups (especially\n\t\t\t\t\tlarge groups) or for preparing reports. Again, use simple language, but use it correctly.\n\t\t\t\t\tGive special attention to how the information is organized. The overall main point\n\t\t\t\t\tmust be stated clearly at the beginning. Each sub-point must then be followed by\n\t\t\t\t\tnecessary details that belong with that particular point. The end should also include\n\t\t\t\t\ta brief summary. This level takes more preparation than do the less formal levels.\n\t\t\t\t\tSee "), _c('span', {
    attrs: {
      "href": "#/chapter02#pz40-1",
      "id": "AgW",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" for more details on organizing information for a report. ")]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "pz36-1"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "id": "Aia"
    }
  }, [_vm._v("Dangerous Doings")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz36-2"
    }
  }, [_vm._v("\n\t\t\t\t\tHow messages are worded can be critical. People often carelessly blurt out whatever\n\t\t\t\t\tis on their mind, and not until it’s out do they realize how poorly the message was\n\t\t\t\t\tcommunicated. Careless communication may hurt feelings, lose someone his or her job\n\t\t\t\t\tor even damage your business. ")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "AK6"
    }
  }, [_c('div', {
    staticClass: "ser",
    attrs: {
      "id": "pAKL"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-right": "1.5em"
    },
    attrs: {
      "alt": "images/img-36-1.jpg",
      "id": "AKL",
      "src": "images/img-36-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pABxA"
    }
  }, [_c('b', [_c('i', [_vm._v("Rule of Thumb:")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "Afg"
    }
  }, [_vm._v("\n\t\t\t\t\t\tBe extremely cautious when using humor in writing. Because of the lack of nonverbal\n\t\t\t\t\t\tcues, attempts at humor in writing most often come across as sarcasm – and sarcasm\n\t\t\t\t\t\tis deadly to any relationship. ")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz36-4"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Sarcasm")]), _vm._v(" can be deadly not only to effective communication but also to relationships,\n\t\t\t\t\tboth business and personal. Sarcasm demeans or degrades someone or someone’s actions,\n\t\t\t\t\tideas, beliefs, etc. No one likes to be put down in such an obnoxious way. "), _c('b', [_c('i', [_vm._v("Avoid\n\t\t\t\t\tsarcasm")])]), _vm._v(". If someone needs correcting over behavior or performance, take that person\n\t\t\t\t\taside and have a talk with him or her. Avoid making sarcastic remarks. Be polite.\n\t\t\t\t\tBe considerate. Make every effort to help that person improve his or her behavior\n\t\t\t\t\twithout using sarcasm or any other type of put-down. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz37-1"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Humor,")]), _vm._v(" especially in writing, can be deadly if extreme caution is not used. Be\n\t\t\t\t\tmindful that in most instances, humor in writing comes across to the reader as sarcasm,\n\t\t\t\t\tand as noted above, sarcasm is deadly to relationships, be they personal or business.\n\t\t\t\t\tThe nonverbal cues that create a large part of the humor (facial expression, smile,\n\t\t\t\t\tfrown, tone of voice, body language, etc.) are missing in the written word. If you\n\t\t\t\t\thappen to be expert at conveying humor, like Jimmy Kimmel or Tina Fey, you may be\n\t\t\t\t\table to pull it off. But keep in mind, those humorists convey their humor through\n\t\t\t\t\tthe medium of television where the viewer sees and hears all the nonverbal cues that\n\t\t\t\t\thelp create the humor. In most instances, avoid trying to be clever and funny in\n\t\t\t\t\twriting. You may end up paying a big price in damaged relationships. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz37-2"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Gossip")]), _vm._v(" has no place in the business world. Most gossip is made up of half-truths\n\t\t\t\t\tor out-and-out untruths. Gossip is often something negative about what may or may\n\t\t\t\t\tnot be happening in the business, with a coworker or to someone in a coworker’s family.\n\t\t\t\t\tTake the high road and stay away from participating in idle gossip. It tends to feed\n\t\t\t\t\ton itself until the “story” becomes totally unrecognizable with little resemblance\n\t\t\t\t\tto any truth. Gossip, like sarcasm, "), _c('span', {
    attrs: {
      "id": "z38-1"
    }
  }, [_vm._v("can be deadly and hurts people. If you rise above\n\t\t\t\t\tthis sort of nonsense, your actions may influence others to do the same. ")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz38-2"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("E-mail, Texting and Instant Messaging")]), _vm._v(" can create problems if you are not careful\n\t\t\t\t\twhat you send. Once information is out there in cyberspace, it’s there for all time.\n\t\t\t\t\tNever send anything electronically that you wouldn’t want as the lead story on CNN,\n\t\t\t\t\ton the front page of the "), _c('i', [_vm._v("New York Times")]), _vm._v(" or anywhere else for the whole world to see.\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "A9F"
    }
  }, [_c('p', {
    staticClass: "ser",
    attrs: {
      "id": "pAaW"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-right": "1.5em"
    },
    attrs: {
      "alt": "images/img-38-1.jpg",
      "id": "AaW",
      "src": "images/img-38-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "pAmXL"
    }
  }, [_c('b', [_c('i', [_vm._v("Rule of Thumb:")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    staticStyle: {
      "text-indent": "0em",
      "margin-left": "3.8em",
      "margin-top": "-0.1em"
    },
    attrs: {
      "id": "Acs"
    }
  }, [_vm._v("\n\t\t\t\t\t\tNEVER, NEVER, NEVER send anything electronically (e-mail, text message, recorded\n\t\t\t\t\t\tphone message, etc.) that is confidential or that you don’t want to see as the lead\n\t\t\t\t\t\tstory on CNN, on the front page of the "), _c('i', [_vm._v("New York Times")]), _vm._v(" or on YouTube. Anything sent\n\t\t\t\t\t\telectronically can be reproduced "), _c('i', [_vm._v("ad infinitum")]), _vm._v(" until the whole world has heard about\n\t\t\t\t\t\tit. An electronic communication can easily be forwarded to 500 people who can each\n\t\t\t\t\t\tforward it on to 500 more and so on and so on. Sensitive or private information should\n\t\t\t\t\t\tbe delivered in hard copy or in person. ")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz39-1"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Organizational Characterization or Attacks")]), _vm._v(" are negative comments about the business\n\t\t\t\t\tfor which you work or about any other business. Making these sorts of comments is\n\t\t\t\t\tunprofessional and does nothing to enhance the business’s image – or yours, for that\n\t\t\t\t\tmatter. Negative comments may hurt other people, damage their reputations and negatively\n\t\t\t\t\taffect their business. My dad always told me that if I couldn’t say something nice,\n\t\t\t\t\tI should say nothing at all. I have found this to be excellent advice. ")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "pz39-2"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_vm._v("•")]), _vm._v(" "), _c('i', [_vm._v("Personal Characterizations or Attacks")]), _vm._v(" on people in your business or in other businesses\n\t\t\t\t\tis also extremely unprofessional. These sorts of remarks are unprofessional, make\n\t\t\t\t\tyou look like “sour grapes” and create a negative image of both you and your business.\n\t\t\t\t\tThey also hurt people and could affect their careers and businesses in both the short\n\t\t\t\t\tand long term. Follow the same advice as for organizational attacks: If you can’t\n\t\t\t\t\tsay something nice, say nothing at all. Be professional at all times. ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baaaf0e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter01.vue
// module id = 75
// module chunks = 0